const KINDS = [
  ['saas', /saas|software|platform|\bapp\b|api\b/i, 'Plans & Products'],
  ['agency', /agency|lead[- ]?gen|marketing|advertis|seo\b/i, 'Services & Packages'],
  ['coach', /coach|consult|course|program|mentor|community|info product|training/i, 'Programs & Offers'],
  ['health', /\b(med ?spa|spa|medical|clinic|dental|dentist|aesthetic|wellness|chiropract\w*|therapy|dermatolog\w*)\b/i, 'Treatments'],
  ['ecom', /\b(e-?commerce|online store|dtc|retail|direct[- ]to[- ]consumer)\b/i, 'Products'],
];

const ORDERS = {
  default: ['overview', 'offers', 'audience', 'faqs', 'proof', 'voice', 'guardrails', 'look'],
  coach: ['overview', 'audience', 'offers', 'faqs', 'proof', 'voice', 'guardrails', 'look'],
};

export const businessLayout = (identity = {}) => {
  const hay = `${identity.business_model || ''} ${identity.industry || ''}`;
  const hit = KINDS.find(([, re]) => re.test(hay));
  const kind = hit ? hit[0] : 'local';
  return {
    kind,
    offersLabel: hit ? hit[2] : 'Services',
    tiered: ['saas', 'agency', 'coach'].includes(kind),
    order: ORDERS[kind] || ORDERS.default,
  };
};

export const hostOf = (url = '') => {
  try { return new URL(url.startsWith('http') ? url : `https://${url}`).hostname.replace(/^www\./, ''); } catch { return ''; }
};

export const faviconFor = url => {
  const host = hostOf(url);
  return host ? `https://www.google.com/s2/favicons?domain=${host}&sz=128` : '';
};

export const SECTION_META = {
  overview: 'Overview', offers: 'Offers', audience: 'Audience', faqs: 'FAQs',
  proof: 'Proof & Trust', voice: 'Voice & Tone', guardrails: 'Guardrails', look: 'Brand Look',
};

export const sectionFilled = (id, b) => {
  const c = b.customers || {}, p = b.proof || {}, t = b.voice_tone || {};
  return {
    overview: !!((b.identity || {}).business_name || (b.identity || {}).tagline),
    offers: (b.offerings || []).length > 0,
    audience: !!(c.target_audience || (c.pain_points || []).length || (c.objections || []).length),
    faqs: (b.faqs || []).length > 0,
    proof: ['guarantees', 'certifications', 'awards', 'review_themes'].some(k => (p[k] || []).length),
    voice: (t.personality_adjectives || []).length > 0 || (t.example_phrases || []).length > 0,
    guardrails: (b.do_not_say || []).length > 0 || (b.competitors || []).length > 0,
    look: (b.colors || []).length > 0 || !!b.logo_url,
  }[id];
};
